"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
require("core-js/modules/es6.function.name");
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var domain = process.env.VUE_APP_BASE_API_ADMIN;
var domain_login = process.env.VUE_APP_BASE_API_LOGIN;
var headerParam = function headerParam() {
  return {
    user: encodeURIComponent(localStorage.name),
    group: encodeURIComponent(localStorage.group)
  };
};
var ServiceModule = /*#__PURE__*/function (_Service) {
  function ServiceModule() {
    (0, _classCallCheck2.default)(this, ServiceModule);
    return _callSuper(this, ServiceModule, arguments);
  }
  (0, _inherits2.default)(ServiceModule, _Service);
  return (0, _createClass2.default)(ServiceModule, [{
    key: "getList",
    value: function getList(param) {
      return this.http.get(domain + "/api/wo?".concat(_qs.default.stringify(param)), {
        headers: _objectSpread({}, headerParam())
      });
    }
    // 获取角色列表
  }, {
    key: "getRoleList",
    value: function getRoleList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("".concat(domain_login, "/vwk/user/roleuser?").concat(_qs.default.stringify(param)));
    }
  }, {
    key: "createEntity",
    value: function createEntity(param) {
      return this.http.post("/api/wo", param, {
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "fetchFieldAttr",
    value: function fetchFieldAttr(param) {
      return this.http.get("/api/woCustomFieldsMap/".concat(param.id));
    }
  }, {
    key: "getCustomizeFields",
    value: function getCustomizeFields(param) {
      return this.http.get("/api/woCustomFields/".concat(param.config_id, "/").concat(param.id));
    }
  }, {
    key: "updateOrderStatus",
    value: function updateOrderStatus(param) {
      return this.http.post("/api/woUpdateStatus", param, {
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "batchUpdateOrderStatus",
    value: function batchUpdateOrderStatus(param) {
      return this.http.post("/api/woBatchUpdateStatus", param, {
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "addMark",
    value: function addMark(param) {
      // 新增用get  。。。
      return this.http.get("/api/mark/create", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "urged",
    value: function urged(param) {
      // 督促处理
      return this.http.get("/api/order/urged", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "getWorkOrderInfo",
    value: function getWorkOrderInfo(param) {
      // 获取工单详情
      return this.http.get("/api/wo/info", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "getDealRecord",
    value: function getDealRecord(param) {
      //  获取处理记录
      return this.http.get("/api/mark/list", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }

    // 获取操作按钮
  }, {
    key: "getOperaBtn",
    value: function getOperaBtn(param) {
      return this.http.get("/api/getOptButton", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
    // 获取工单用户vip等级
  }, {
    key: "getUserLevel",
    value: function getUserLevel(param) {
      return this.http.get("/api/wo/getUserLev", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
    // 查看私密备注
  }, {
    key: "getLookPrivacy",
    value: function getLookPrivacy(param) {
      return this.http.get("/api/getPrivateMark", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
    // 撤销
  }, {
    key: "revocation",
    value: function revocation(param) {
      return this.http.get("/api/workorders/undo", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }

    // 转单
  }, {
    key: "transcription",
    value: function transcription(data) {
      return this.http.post("/api/workorders/turn_single", data, {
        headers: _objectSpread({}, headerParam())
      });
    }
    // 标记观察工单处理
  }, {
    key: "markObservation",
    value: function markObservation(param) {
      return this.http.post("/api/workorders/edit_tagstatus", param, {
        headers: _objectSpread({}, headerParam())
      });
    }

    // 工单修改
  }, {
    key: "markEdit",
    value: function markEdit(id, param) {
      return this.http.put("/api/wo/" + id, param, {
        headers: _objectSpread({}, headerParam())
      });
    }

    // 获取工单统计总表列表
  }, {
    key: "getWorkListAll",
    value: function getWorkListAll(param) {
      return this.http.get("/api/all/get_order_total", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
    // 获取工单模块(用于搜索)
  }, {
    key: "getWorkSearch",
    value: function getWorkSearch(param) {
      return this.http.get("/api/all/worker_roder_plate", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }
    // 获取工单问题列表
  }, {
    key: "getWorkIssue",
    value: function getWorkIssue(param) {
      return this.http.get("/api/all/worker_roder_question/".concat(param.config_id, "/").concat(param.type_id));
    }
    // 获取工单分类列表
  }, {
    key: "getWorkClassify",
    value: function getWorkClassify(param) {
      return this.http.get("/api/all/worker_roder_type/".concat(param.config_id));
    }

    // 详细报表
  }, {
    key: "getWorkListDetail",
    value: function getWorkListDetail(param) {
      return this.http.get("/api/all/get_order_info", {
        params: _objectSpread({}, param),
        headers: _objectSpread({}, headerParam())
      });
    }

    // 详细报表-导出
  }, {
    key: "detailReport",
    value: function detailReport(param) {
      return this.http.get("/api/all/get_export", {
        params: param
      }, {
        headers: {
          user: String(localStorage.getItem("userName"))
        }
      });
    }

    // 获取徽标数量接口
  }, {
    key: "number",
    value: function number() {
      return this.http.get("/api/all/my_edit_order", {
        headers: _objectSpread({}, headerParam())
      });
    }
    // 获取铃铛数量显示
  }, {
    key: "numberMessage",
    value: function numberMessage() {
      return this.http.get("/api/all/my_message", {
        headers: _objectSpread({}, headerParam())
      });
    }
    // 工单处理记录
  }, {
    key: "workRecord",
    value: function workRecord(param) {
      return this.http.get("/api/mark/list", {
        params: param
      });
    }
    // 转单信息
  }, {
    key: "workOrderMessage",
    value: function workOrderMessage(data) {
      return this.http.post("/api/workorders/turn_single", data);
    }
    // 根据工单信息返回权限信息
  }, {
    key: "workOrderLimit",
    value: function workOrderLimit(id) {
      return this.http.get("/api/order/config/" + id);
    }
  }, {
    key: "getUrl",
    value: function getUrl(param) {
      return this.http.get(param, {
        responseType: "blob"
      });
    }
  }, {
    key: "topList",
    value: function topList(param) {
      return this.http.post("/api/pin/overtime", param);
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new ServiceModule();